import React, { ReactNode, useState } from 'react';
import Grid from '@mui/material/Grid';
import { Image } from 'components';
import { ImgWrapper, QuoteAuthor, QuoteSection } from './styled';

interface ITestimonialItem {
  name: string;
  imgUrl: string;
  text: string | ReactNode;
}

function TestimonialItem({
  imgUrl,
  text,
  name
}: ITestimonialItem): JSX.Element {
  const [isOpen, setOpen] = useState(false);
  const handleOpen = () => setOpen(!isOpen);
  return (
    <Grid
      data-testid="testimonial"
      container
      padding="0"
      height="100%"
      alignItems="top">
      <Grid item xs={3} sm={4} paddingX={{ xs: 1, sm: 0 }}>
        <ImgWrapper
          onClick={handleOpen}
          sx={{
            '& a': {
              width: { xs: '100%', md: '100%' },
              height: { xs: 'auto', md: 'auto' }
            }
          }}>
          <Image src={imgUrl} alt={name} height={161} width={161} />
        </ImgWrapper>
      </Grid>

      <Grid item xs={9} sm={8} paddingX={1}>
        <QuoteSection>
          <div>&quot;{text}&quot;</div>
          <QuoteAuthor>{name}</QuoteAuthor>
        </QuoteSection>
      </Grid>
    </Grid>
  );
}

export default TestimonialItem;
